// extracted by mini-css-extract-plugin
module.exports =  {"kinescope-player":"_93444fe79c--kinescope-player--GsYS8","kinescope-player--visible":"_93444fe79c--kinescope-player--visible--dKzny"};